"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClerkProvider = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));

var errors_1 = require("../errors");

var isomorphicClerk_1 = tslib_1.__importDefault(require("../isomorphicClerk"));

var utils_1 = require("../utils");

var ClerkContextProvider_1 = require("./ClerkContextProvider");

var StructureContext_1 = require("./StructureContext");

function ClerkProviderBase(props) {
  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      clerkLoaded = _ref2[0],
      setClerkLoaded = _ref2[1];

  var clerk = (0, react_1.useMemo)(function () {
    var _props$frontendApi = props.frontendApi,
        frontendApi = _props$frontendApi === void 0 ? '' : _props$frontendApi,
        ClerkConstructor = props.Clerk,
        initialState = props.initialState,
        options = tslib_1.__rest(props, ["frontendApi", "Clerk", "initialState"]);

    return isomorphicClerk_1.default.getOrCreateInstance({
      frontendApi: frontendApi,
      options: options,
      Clerk: ClerkConstructor,
      initialState: initialState
    });
  }, []);
  (0, react_1.useEffect)(function () {
    void clerk.loadClerkJS().then(function () {
      return setClerkLoaded(true);
    });
  }, []);
  return react_1.default.createElement(StructureContext_1.StructureContext.Provider, {
    value: StructureContext_1.StructureContextStates.noGuarantees
  }, react_1.default.createElement(ClerkContextProvider_1.ClerkContextProvider, {
    isomorphicClerk: clerk,
    clerkLoaded: clerkLoaded
  }, props.children));
}

var ClerkProvider = (0, utils_1.withMaxAllowedInstancesGuard)(ClerkProviderBase, 'ClerkProvider', errors_1.multipleClerkProvidersError);
exports.ClerkProvider = ClerkProvider;
ClerkProvider.displayName = 'ClerkProvider';